export default "__VITE_ASSET__PIS82Sbl__"